import React from 'react'

import * as S from './styles'

export interface iButton {
    name: React.ReactNode | string;
    disabled?: boolean;
    className?: string;
    onClick: () => void;
    to?: string;
    isTransparent?: boolean;
}

const Button: React.FC<iButton> = ({ name, className, disabled, onClick, to, isTransparent }) => {
    return to ?
        (<S.ButtonLink to={to} className={className} istransparent={isTransparent}>
            {name}
        </S.ButtonLink>)
        :
        (<S.Button className={className} onClick={onClick} type="button" disabled={disabled} istransparent={isTransparent}>
            {name}
        </S.Button>)   
}

export default Button